<template>
  <div>
    <form>
      <v-textarea
        v-model="note"
        :error-messages="getViolation('note')"
        :label="$t('custom_message')"
        variant="outlined"
        auto-grow
        rows="3"
      />
      <v-btn
        :loading="loading"
        size="large"
        variant="flat"
        color="#000"
        @click="addToCart"
      >
        <v-icon start>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            fill="currentColor"
          >
            <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
          </svg>
        </v-icon>
        {{ $t('add_to_cart') }}
      </v-btn>
    </form>
  </div>
</template>

<script>
import Axios from '../ajax'
import Qs from 'qs'
import { errorMixin } from '../mixins/error-mixin'

export default {
  name: 'VFormAddToCart',
  mixins: [
    errorMixin
  ],
  props: {
    productId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      note: null
    }
  },
  methods: {
    async addToCart () {
      this.clearViolations()
      this.loading = true

      try {
        await Axios.post('/kosik.json', Qs.stringify({
          product: this.productId,
          note: this.note,
          quantity: 1
        }))

        this.redirectBasedOnLocale()

      } catch (err) {
        this.buildViolations(err.response)
      }

      this.loading = false

    },
    redirectBasedOnLocale () {
      const locale = document.documentElement.lang || 'cs'
      window.location.href = locale === 'en' ? '/en/cart' : '/cs/kosik'
    }
  }
}
</script>
